// ----------------------------------------------------------------------------
// Component: Content Cards
// ----------------------------------------------------------------------------
//
// Section displaying a default card consisting of an image,
// title, content and button. It displays a 1, 2 or 3 column grid.
//
//
// ----------------------------------------------------------------------------

// Style includes
import './_multicolumn.scss';

// Content card video modal
import 'snippets/video-player/video-player';
import 'snippets/_containers/modal/modal';

// -------------------------------------
// Variables
// -------------------------------------
var SECTION_SELECTOR = '.multicolumn';
var BLOCKS_SELECTOR = '.multicolumn__blocks';
var EYEBROW_ROW_SELECTOR = '.card__content--blocks > .shopify-block:has(> .text--eyebrow)';
var TITLE_ROW_SELECTOR = '.card__content--blocks > .shopify-block:has(> :is(h1, h2, h3, h4, h5, h6)) > :is(h1, h2, h3, h4, h5, h6)';

// -------------------------------------
// Helpers
// -------------------------------------
var getMaxHeight = elements => elements.reduce((maxHeight, element) => {
  return Math.max(maxHeight, Math.ceil(element.getBoundingClientRect().height));
}, 0);
var syncSectionRowHeights = section => {
  var blocks = section.querySelector(BLOCKS_SELECTOR);
  if (!blocks) return;
  blocks.style.removeProperty('--multicolumn-eyebrow-height');
  blocks.style.removeProperty('--multicolumn-title-height');
  var eyebrowRows = Array.from(blocks.querySelectorAll(EYEBROW_ROW_SELECTOR));
  var titleRows = Array.from(blocks.querySelectorAll(TITLE_ROW_SELECTOR));
  var maxEyebrowHeight = getMaxHeight(eyebrowRows);
  var maxTitleHeight = getMaxHeight(titleRows);
  if (maxEyebrowHeight) {
    blocks.style.setProperty('--multicolumn-eyebrow-height', "".concat(maxEyebrowHeight, "px"));
  }
  if (maxTitleHeight) {
    blocks.style.setProperty('--multicolumn-title-height', "".concat(maxTitleHeight, "px"));
  }
};
var syncAllMulticolumnRowHeights = () => {
  document.querySelectorAll(SECTION_SELECTOR).forEach(syncSectionRowHeights);
};
var syncFrame = null;
var queueMulticolumnSync = () => {
  if (syncFrame) return;
  syncFrame = window.requestAnimationFrame(() => {
    syncFrame = null;
    syncAllMulticolumnRowHeights();
  });
};
var initMulticolumn = () => {
  var _document$fonts;
  queueMulticolumnSync();
  (_document$fonts = document.fonts) === null || _document$fonts === void 0 || _document$fonts.ready.then(queueMulticolumnSync);
  window.addEventListener('load', queueMulticolumnSync);
  window.addEventListener('resize', queueMulticolumnSync);
  document.addEventListener('shopify:section:load', queueMulticolumnSync);
  document.addEventListener('shopify:block:select', queueMulticolumnSync);
};

// -------------------------------------
// Hooks
// -------------------------------------
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMulticolumn);
} else {
  initMulticolumn();
}